import React from 'react';
import Icon from '../../../components/AppIcon';
import { fieldLabel } from './fieldLabels';

/**
 * The list shown after a blocked Next/Submit. Friendly names come from fieldLabels.js (shared with
 * the hint beside Next); with `onFieldClick` each name jumps to its field.
 */
const ErrorSummary = ({ errors, currentStep, onFieldClick }) => {
  const errorCount = Object.keys(errors).length;

  if (errorCount === 0) return null;

  const getStepName = (step) => {
    const stepNames = {
      1: 'Company Information',
      2: 'Address Details',
      3: 'Bank Information',
      4: 'Categorization',
      5: 'Compliance',
      6: 'Agreements'
    };
    return stepNames[step] || `Step ${step}`;
  };

  return (
    <div
      id="registration-error-summary"
      tabIndex={-1}
      className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-md shadow-sm outline-none"
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Icon name="AlertCircle" className="h-6 w-6 text-red-600" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-semibold text-red-800">
            {errorCount === 1
              ? 'Please fix the following error to continue:'
              : `Please fix the following ${errorCount} errors to continue:`
            }
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="list-disc list-inside space-y-1">
              {Object.entries(errors).map(([field, message]) => {
                const label = fieldLabel(field);
                return (
                  <li key={field} className="leading-relaxed">
                    {onFieldClick && field !== 'submit' ? (
                      <button
                        type="button"
                        onClick={() => onFieldClick(field)}
                        className="rounded-sm font-medium underline underline-offset-2 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
                      >
                        {label}
                      </button>
                    ) : (
                      <span className="font-medium">{label}</span>
                    )}
                    <span className="font-medium">:</span>{' '}
                    <span className="text-red-600">{message}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="mt-3 text-xs text-red-600 font-medium">
            <Icon name="Info" className="inline h-4 w-4 mr-1" />
            {onFieldClick
              ? 'Select a field name to jump straight to it.'
              : 'Scroll down to see the highlighted fields that need correction.'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorSummary;
